import { __commonJS } from "./chunk-B4qE4VCv.mjs";
import { require_function } from "./function-CN-GVuiB.mjs";
import { require_Apply, require_Chain, require_Functor, require_internal } from "./Functor-CElCX-_O.mjs";

//#region node_modules/.deno/fp-ts@2.16.10/node_modules/fp-ts/lib/Applicative.js
var require_Applicative = /* @__PURE__ */ __commonJS({ "node_modules/.deno/fp-ts@2.16.10/node_modules/fp-ts/lib/Applicative.js": ((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.getApplicativeMonoid = getApplicativeMonoid;
	exports.getApplicativeComposition = getApplicativeComposition;
	/**
	* The `Applicative` type class extends the `Apply` type class with a `of` function, which can be used to create values
	* of type `f a` from values of type `a`.
	*
	* Where `Apply` provides the ability to lift functions of two or more arguments to functions whose arguments are
	* wrapped using `f`, and `Functor` provides the ability to lift functions of one argument, `pure` can be seen as the
	* function which lifts functions of _zero_ arguments. That is, `Applicative` functors support a lifting operation for
	* any number of function arguments.
	*
	* Instances must satisfy the following laws in addition to the `Apply` laws:
	*
	* 1. Identity: `A.ap(A.of(a => a), fa) <-> fa`
	* 2. Homomorphism: `A.ap(A.of(ab), A.of(a)) <-> A.of(ab(a))`
	* 3. Interchange: `A.ap(fab, A.of(a)) <-> A.ap(A.of(ab => ab(a)), fab)`
	*
	* Note. `Functor`'s `map` can be derived: `A.map(x, f) = A.ap(A.of(f), x)`
	*
	* @since 2.0.0
	*/
	var Apply_1 = require_Apply();
	var function_1$2 = require_function();
	var Functor_1$1 = require_Functor();
	function getApplicativeMonoid(F) {
		var f = (0, Apply_1.getApplySemigroup)(F);
		return function(M) {
			return {
				concat: f(M).concat,
				empty: F.of(M.empty)
			};
		};
	}
	/** @deprecated */
	function getApplicativeComposition(F, G) {
		var map$1 = (0, Functor_1$1.getFunctorComposition)(F, G).map;
		var _ap = (0, Apply_1.ap)(F, G);
		return {
			map: map$1,
			of: function(a) {
				return F.of(G.of(a));
			},
			ap: function(fgab, fga) {
				return (0, function_1$2.pipe)(fgab, _ap(fga));
			}
		};
	}
}) });

//#endregion
//#region node_modules/.deno/fp-ts@2.16.10/node_modules/fp-ts/lib/FromEither.js
var require_FromEither = /* @__PURE__ */ __commonJS({ "node_modules/.deno/fp-ts@2.16.10/node_modules/fp-ts/lib/FromEither.js": ((exports) => {
	/**
	* The `FromEither` type class represents those data types which support errors.
	*
	* @since 2.10.0
	*/
	var __createBinding$1 = exports && exports.__createBinding || (Object.create ? (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		var desc = Object.getOwnPropertyDescriptor(m, k);
		if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
			enumerable: true,
			get: function() {
				return m[k];
			}
		};
		Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		o[k2] = m[k];
	}));
	var __setModuleDefault$1 = exports && exports.__setModuleDefault || (Object.create ? (function(o, v) {
		Object.defineProperty(o, "default", {
			enumerable: true,
			value: v
		});
	}) : function(o, v) {
		o["default"] = v;
	});
	var __importStar$1 = exports && exports.__importStar || function(mod) {
		if (mod && mod.__esModule) return mod;
		var result = {};
		if (mod != null) {
			for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$1(result, mod, k);
		}
		__setModuleDefault$1(result, mod);
		return result;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.fromOption = fromOption;
	exports.fromPredicate = fromPredicate;
	exports.fromOptionK = fromOptionK;
	exports.chainOptionK = chainOptionK;
	exports.fromEitherK = fromEitherK;
	exports.chainEitherK = chainEitherK;
	exports.chainFirstEitherK = chainFirstEitherK;
	exports.filterOrElse = filterOrElse;
	exports.tapEither = tapEither;
	var Chain_1 = require_Chain();
	var function_1$1 = require_function();
	var _$1 = __importStar$1(require_internal());
	function fromOption(F) {
		return function(onNone) {
			return function(ma) {
				return F.fromEither(_$1.isNone(ma) ? _$1.left(onNone()) : _$1.right(ma.value));
			};
		};
	}
	function fromPredicate(F) {
		return function(predicate, onFalse) {
			return function(a) {
				return F.fromEither(predicate(a) ? _$1.right(a) : _$1.left(onFalse(a)));
			};
		};
	}
	function fromOptionK(F) {
		var fromOptionF = fromOption(F);
		return function(onNone) {
			var from = fromOptionF(onNone);
			return function(f) {
				return (0, function_1$1.flow)(f, from);
			};
		};
	}
	function chainOptionK(F, M) {
		var fromOptionKF = fromOptionK(F);
		return function(onNone) {
			var from = fromOptionKF(onNone);
			return function(f) {
				return function(ma) {
					return M.chain(ma, from(f));
				};
			};
		};
	}
	function fromEitherK(F) {
		return function(f) {
			return (0, function_1$1.flow)(f, F.fromEither);
		};
	}
	function chainEitherK(F, M) {
		var fromEitherKF = fromEitherK(F);
		return function(f) {
			return function(ma) {
				return M.chain(ma, fromEitherKF(f));
			};
		};
	}
	function chainFirstEitherK(F, M) {
		var tapEitherM = tapEither(F, M);
		return function(f) {
			return function(ma) {
				return tapEitherM(ma, f);
			};
		};
	}
	function filterOrElse(F, M) {
		return function(predicate, onFalse) {
			return function(ma) {
				return M.chain(ma, function(a) {
					return F.fromEither(predicate(a) ? _$1.right(a) : _$1.left(onFalse(a)));
				});
			};
		};
	}
	/** @internal */
	function tapEither(F, M) {
		var fromEither = fromEitherK(F);
		var tapM = (0, Chain_1.tap)(M);
		return function(self, f) {
			return tapM(self, fromEither(f));
		};
	}
}) });

//#endregion
//#region node_modules/.deno/fp-ts@2.16.10/node_modules/fp-ts/lib/Separated.js
var require_Separated = /* @__PURE__ */ __commonJS({ "node_modules/.deno/fp-ts@2.16.10/node_modules/fp-ts/lib/Separated.js": ((exports) => {
	/**
	* ```ts
	* interface Separated<E, A> {
	*    readonly left: E
	*    readonly right: A
	* }
	* ```
	*
	* Represents a result of separating a whole into two parts.
	*
	* @since 2.10.0
	*/
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.right = exports.left = exports.flap = exports.Functor = exports.Bifunctor = exports.URI = exports.bimap = exports.mapLeft = exports.map = exports.separated = void 0;
	var function_1 = require_function();
	var Functor_1 = require_Functor();
	/**
	* @category constructors
	* @since 2.10.0
	*/
	var separated = function(left$1, right$1) {
		return {
			left: left$1,
			right: right$1
		};
	};
	exports.separated = separated;
	var _map = function(fa, f) {
		return (0, function_1.pipe)(fa, (0, exports.map)(f));
	};
	var _mapLeft = function(fa, f) {
		return (0, function_1.pipe)(fa, (0, exports.mapLeft)(f));
	};
	var _bimap = function(fa, g, f) {
		return (0, function_1.pipe)(fa, (0, exports.bimap)(g, f));
	};
	/**
	* `map` can be used to turn functions `(a: A) => B` into functions `(fa: F<A>) => F<B>` whose argument and return types
	* use the type constructor `F` to represent some computational context.
	*
	* @category mapping
	* @since 2.10.0
	*/
	var map = function(f) {
		return function(fa) {
			return (0, exports.separated)((0, exports.left)(fa), f((0, exports.right)(fa)));
		};
	};
	exports.map = map;
	/**
	* Map a function over the first type argument of a bifunctor.
	*
	* @category error handling
	* @since 2.10.0
	*/
	var mapLeft = function(f) {
		return function(fa) {
			return (0, exports.separated)(f((0, exports.left)(fa)), (0, exports.right)(fa));
		};
	};
	exports.mapLeft = mapLeft;
	/**
	* Map a pair of functions over the two type arguments of the bifunctor.
	*
	* @category mapping
	* @since 2.10.0
	*/
	var bimap = function(f, g) {
		return function(fa) {
			return (0, exports.separated)(f((0, exports.left)(fa)), g((0, exports.right)(fa)));
		};
	};
	exports.bimap = bimap;
	/**
	* @category type lambdas
	* @since 2.10.0
	*/
	exports.URI = "Separated";
	/**
	* @category instances
	* @since 2.10.0
	*/
	exports.Bifunctor = {
		URI: exports.URI,
		mapLeft: _mapLeft,
		bimap: _bimap
	};
	/**
	* @category instances
	* @since 2.10.0
	*/
	exports.Functor = {
		URI: exports.URI,
		map: _map
	};
	/**
	* @category mapping
	* @since 2.10.0
	*/
	exports.flap = (0, Functor_1.flap)(exports.Functor);
	/**
	* @since 2.10.0
	*/
	var left = function(s) {
		return s.left;
	};
	exports.left = left;
	/**
	* @since 2.10.0
	*/
	var right = function(s) {
		return s.right;
	};
	exports.right = right;
}) });

//#endregion
//#region node_modules/.deno/fp-ts@2.16.10/node_modules/fp-ts/lib/Witherable.js
var require_Witherable = /* @__PURE__ */ __commonJS({ "node_modules/.deno/fp-ts@2.16.10/node_modules/fp-ts/lib/Witherable.js": ((exports) => {
	var __createBinding = exports && exports.__createBinding || (Object.create ? (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		var desc = Object.getOwnPropertyDescriptor(m, k);
		if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
			enumerable: true,
			get: function() {
				return m[k];
			}
		};
		Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		o[k2] = m[k];
	}));
	var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? (function(o, v) {
		Object.defineProperty(o, "default", {
			enumerable: true,
			value: v
		});
	}) : function(o, v) {
		o["default"] = v;
	});
	var __importStar = exports && exports.__importStar || function(mod) {
		if (mod && mod.__esModule) return mod;
		var result = {};
		if (mod != null) {
			for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
		}
		__setModuleDefault(result, mod);
		return result;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.wiltDefault = wiltDefault;
	exports.witherDefault = witherDefault;
	exports.filterE = filterE;
	var _ = __importStar(require_internal());
	function wiltDefault(T, C) {
		return function(F) {
			var traverseF = T.traverse(F);
			return function(wa, f) {
				return F.map(traverseF(wa, f), C.separate);
			};
		};
	}
	function witherDefault(T, C) {
		return function(F) {
			var traverseF = T.traverse(F);
			return function(wa, f) {
				return F.map(traverseF(wa, f), C.compact);
			};
		};
	}
	function filterE(W) {
		return function(F) {
			var witherF = W.wither(F);
			return function(predicate) {
				return function(ga) {
					return witherF(ga, function(a) {
						return F.map(predicate(a), function(b) {
							return b ? _.some(a) : _.none;
						});
					});
				};
			};
		};
	}
}) });

//#endregion
export { require_Applicative, require_FromEither, require_Separated, require_Witherable };